import * as XLSX from "xlsx/xlsx.mjs";
import { saveAs } from "file-saver";

export const exportToExcel = (tableData) => {
  const worksheet = XLSX.utils.json_to_sheet(tableData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Prize History 2023");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const fileName = "prize_history.xlsx";
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    fileName
  );
};
